import validate from '../../../services/reduxValidate.js'

export default function(data) {
  return validate(data, {
    langue: { presence: { allowEmpty: false } },
    description: { presence: { allowEmpty: false } },
  })
}